import React, { useCallback } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { cn } from '@/utils/cn';
import useBodyOverflow from '@/app/hooks/useBodyOverflow';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@/app/components/Button';
import Icon from '@/app/components/Icon';
import StoreLocator from '@/app/components/StoreLocator';
import Text from '@/app/components/Text';
import {
  updateCurrentMenu,
  updateIsMenuOpeStatus,
} from '@/redux/reducers/hamburger-menu-reducer';
import LoginPromotionBanner from '../Auth/LoginPromotionBanner';
import CheckOrderStatusGuest from '../Order/CheckOrderStatusGuest';

function MenuSections({ menuSections }) {
  const dispatch = useDispatch();
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();

  // hooks
  useBodyOverflow(!!menuSections);

  // store
  const { isMenuOpen } = useSelector((state) => state.hamburgerMenu);
  const { isLoggedIn } = useSelector((state) => state.auth);

  const selectMenuHandler = useCallback(
    (selectedMenu) => {
      if (selectedMenu.url) {
        dispatch(updateIsMenuOpeStatus(false));
        router.push(selectedMenu.url);
      } else {
        dispatch(updateCurrentMenu(selectedMenu));
        // const current = new URLSearchParams(Array.from(searchParams.entries()))
        // current.set('menu', selectedMenu.id)
        // const url = `${pathname}?${current.toString()}`
        // router.push(url)
      }
    },
    [pathname, router, searchParams],
  );

  const loginPromotionHandler = () => {
    router.push('/login');
    dispatch(updateIsMenuOpeStatus(false));
  };

  const onSubmitHandler = () => {
    dispatch(updateIsMenuOpeStatus(false));
  };

  return (
    <div
      className={cn(
        'flex lg:hidden bg-white p-16 fixed z-[1000] w-full left-0 top-0 pb-[100px] h-full',
        {
          'overflow-y-auto': isMenuOpen,
        },
      )}
    >
      <div className="w-full">
        <Button
          type="link"
          className="flex items-center gap-[8px] !p-0 mb-16"
          onClick={() => dispatch(updateIsMenuOpeStatus(false))}
        >
          <Icon type="arrow-left" className="size-[20px]" color="#49525E" />
          <Text type="paragraph" className="text-sm text-senate font-semibold">
            Go back
          </Text>
        </Button>

        {/* guest user */}
        {!isLoggedIn ? (
          <div className="guest-view flex flex-col w-full gap-4">
            <LoginPromotionBanner
              loginPromotionHandler={loginPromotionHandler}
            />
            {!isLoggedIn ? (
              <section className="guest-order-status flex flex-col gap-1 w-full px-8 py-12 rounded-xl shadow-contact-us bg-white">
                <CheckOrderStatusGuest onSubmitHandler={onSubmitHandler} />
              </section>
            ) : null}
          </div>
        ) : null}

        <div className="flex flex-col gap-5 mt-20 w-full">
          {menuSections?.map((section, sectionIndex) => {
            if (!isLoggedIn && section.label === 'My Singer') {
              return null;
            }
            return (
              <section key={sectionIndex} className="flex flex-col gap-3">
                {section?.isLanguageOption ? null : ( // </div> //   /> //     isHamBurgerMenu //     option={section.menu} //     type="dropdown" //   <UserInput TODO: POST MVP // <div className="flex">
                  <>
                    <div className="flex justify-between">
                      <Text type="navigation_title">{section.label}</Text>
                      {section?.isStoreLocator ? (
                        <div
                          role="presentation"
                          onClick={() => dispatch(updateIsMenuOpeStatus(false))}
                        >
                          <StoreLocator isHamBurgerMenu />
                        </div>
                      ) : null}
                    </div>

                    <div className="flex flex-col gap-2">
                      {section.menu?.map((menu, menuIndex) => (
                        <div
                          className="flex items-center gap-2 px-16 py-10 rounded-xl shadow-contact-us hover:cursor-pointer"
                          key={menuIndex}
                          role="presentation"
                          onClick={() => selectMenuHandler(menu)}
                        >
                          {menu.icon ? (
                            <Icon
                              type={menu.icon}
                              width="20"
                              height="20"
                              className="size-[20px]"
                              color="#49525E"
                            />
                          ) : null}

                          <Text
                            type="paragraph"
                            className="text-sm text-coarse-wool font-semibold"
                          >
                            {menu.label}
                          </Text>

                          <Icon
                            type="thin-right-arrow"
                            width="20"
                            height="20"
                            className="ml-auto"
                            color="#49525E"
                          />
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default MenuSections;
